export interface DoctorNameFields {
  doctor_fname?: string | null
  doctor_name?: string | null
  doctor_fname_en?: string | null
}

export function getDoctorDisplayNamei18n(
  doctor: DoctorNameFields,
  lang = 'th',
  fallback = '',
): string {
  const th = doctor.doctor_fname || doctor.doctor_name || fallback
  const en = doctor.doctor_fname_en || th

  if (lang === 'cn' || lang === 'en') return en
  return th
}
